import TransformModel from './TransformModel';
import PropertyDescriptor from '../utils/PropertyDescriptor';

export default class BordableModel extends TransformModel {

    borderWidth = new PropertyDescriptor(1, '边框宽度', "边框与填充", "double", "#anticon-visualization-border", {
        gallery: "外观",
        galleryIndex: 60,
        catalogIndex: 40
    });
    borderStyle = new PropertyDescriptor('solid', '边框风格', "边框与填充", "enum", "#anticon-border-top", {
        gallery: "外观",
        values: [
            new PropertyDescriptor("solid", undefined, "边框风格", "string"),
            new PropertyDescriptor("dashed", undefined, "边框风格", "string"),
            new PropertyDescriptor("dotted", undefined, "边框风格", "string"),
            new PropertyDescriptor("double", undefined, "边框风格", "string"),
            new PropertyDescriptor("groove", undefined, "边框风格", "string"),
            new PropertyDescriptor("inset", undefined, "边框风格", "string"),
            new PropertyDescriptor("outset", undefined, "边框风格", "string"),
            new PropertyDescriptor("ridge", undefined, "边框风格", "string"),
            new PropertyDescriptor("hidden", undefined, "边框风格", "string"),
            new PropertyDescriptor("none", undefined, "边框风格", "string"),
            new PropertyDescriptor("unset", undefined, "边框风格", "string"),
        ]
    });
    borderColor = new PropertyDescriptor('#666', '边框颜色', "边框与填充", "color", "#anticon-edit3", {
        gallery: "外观",
    });
    backgroundImage = new PropertyDescriptor('', '背景图片', "边框与填充", "image", "#anticon-image", {
        gallery: "外观", placeholder: '请输入一个图片地址', description: "您需要输入一个网络地址，例如：http://yulintu.com/images/logo.png"
    });
    backgroundColor = new PropertyDescriptor('#fff', '背景颜色', "边框与填充", "color", "#anticon-backgroundred", {
        gallery: "外观",
    });

    onPropertyValueChanged(name, valOld, valNew, subName, args) {
        super.onPropertyValueChanged(name, valOld, valNew, subName, args);

        if (name === "borderStyle" && subName === undefined)
            this.setPropertyVisible("borderWidth", valNew !== "none");
    }

    enableBordableModelProperties(enabled) {
        this.borderWidth.enabled = enabled;
        this.borderStyle.enabled = enabled;
        this.borderColor.enabled = enabled;
        this.backgroundImage.enabled = enabled;
        this.backgroundColor.enabled = enabled;
    }

    toStyle() {

        // return `
        //     border-width: ${this.borderWidth};
        //     border-color: ${this.borderColor};
        //     border-style: ${this.borderStyle};
        //     background-color: ${this.backgroundColor};
        //     ${super.getExtendStyle()}
        // `

        return {
            borderWidth: this.borderWidth,
            borderColor: this.borderColor,
            borderStyle: this.borderStyle,
            padding: this.padding.toString(),
            backgroundColor: `${this.backgroundColor}`,
            backgroundImage: this.backgroundImage && this.backgroundImage.trim() ? "url('" + this.backgroundImage.trim() + "')" : "",
            backgroundSize: '100% 100%',
            ...super.getExtendStyle(),
        }
    }
}
